import { FC } from 'react';

// Third-party
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

// Types
import { useTranslation } from 'react-i18next';
import { TSubmissionListWrapper } from '../type';

// Assets
import { ReactComponent as noDataIcon } from '../../../../static/icons/tasklists/ic_no_data.svg';

const SubmissionListWrapper: FC<TSubmissionListWrapper> = ({
  isSubmissionsEmpty,
  children,
}) => {
  const { t } = useTranslation('tasklists');

  return (
    <Box>
      {!isSubmissionsEmpty ? (
        children
      ) : (
        <Box
          marginX="auto"
          marginTop={10}
          sx={{
            width: 200,
            height: 200,
            lineHeight: 0,
            borderRadius: '50%',
            bgcolor: 'background.neutral',
          }}
        >
          <SvgIcon
            sx={{
              width: '100%',
              height: '100%',
            }}
            component={noDataIcon}
            inheritViewBox
          />
          <Box marginTop={4}>
            <Typography textAlign="center" variant="subtitle2">{t('noSubmissions')}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export {
  SubmissionListWrapper,
};
